var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurfing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Surfing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Surfing",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_surfing_3936544_000000",
    transform: "translate(9.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,20.7284713 C24.9114934,19.0880872 24.7525903,17.5045419 24.5373639,16 L5.03017196,21.9491305 C5.03017196,22.5574358 5,23.1636647 5,23.7861926 C5,24.8709577 5.03620594,25.9395276 5.09252824,27 L25,20.7284713 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8692162,0 C9.84238108,0 5.79440541,8.0712 5,19 L24,13.3298933 C22.4273649,5.39144 18.9772216,0 14.8692162,0 L14.8692162,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9677935,39.9728366 L22.1936,39.9728366 C23.9940129,35.7301216 25.012129,29.9786785 25.012129,23.8810206 L25.012129,23 L5.16129032,29.0758643 C5.47782194,32.8117504 6.3467871,36.4821543 7.74193548,39.9726846 L1.03225806,39.9726846 C0.461677419,39.9726846 0,40.4260582 0,40.9863423 C0,41.5466264 0.461692903,42 1.03225806,42 L30.9677419,42 C31.5383226,42 32,41.5466264 32,40.9863423 C32,40.4260582 31.5383071,39.9726846 30.9677419,39.9726846 L30.9677935,39.9728366 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfing);
export default ForwardRef;